















import Vue from "vue";
import { VDialog, VCard } from "vuetify/lib";
import { defineComponent } from "@vue/composition-api";
import { castComponent } from "@/lib/helpers";

Vue.component("VDialog", castComponent(VDialog));
Vue.component("VCard", castComponent(VCard));

export default defineComponent({
  name: "ModalContainer",
});
